module.exports = __webpack_public_path__ + "fa875bf21f4c703ea8f1cac838be928c.svg";